var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-box" },
    [
      _c("van-nav-bar", {
        attrs: { title: "资料编号", "left-arrow": "" },
        on: { "click-left": _vm.back }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c(
            "van-cell-group",
            { attrs: { inset: "" } },
            _vm._l(_vm.dataList, function(item, index) {
              return _c("van-cell", { key: index, attrs: { title: item } })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dad175c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dad175c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/mobile/DataInfo.vue
// module id = Ri8i
// module chunks = 1